// extracted by mini-css-extract-plugin
export default {"Experience":"Experience_Experience__3TklM","slide-in":"Experience_slide-in__KSulB","Heading":"Experience_Heading__EsLh-","Description":"Experience_Description__7Eko+"};